import React 				from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent			from '../../../../core/_BLComponent.jsx';

export default class FifthSlide extends BLComponent 
{
	
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

	}

	componentDidMount() 
	{

	}

	render()
	{
		const {slidePrev, slideNext} = this.props.func;
		return (
			<div>
				<div className="l-flex l-full-width">
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
					<div className="l-full-width">
						<div className="text--center text--bold">
							Let’s get started
						</div>
					</div>
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
				</div>

				<div className="l-flex">
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
					<div className="text--small l-margin-top--xl l-full-width text--center">
						Gather all your LEGO® sets, parts, minifigures, gear, books, and catalogs and start building your collection today!
					</div>
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
				</div>

				<div className="l-flex l-margin-top--xl l-margin-bottom--xl">
					<div className="text--small text--center" style={{margin:"auto"}}>
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/personal-inventory/explore-box.webp"} />
					</div>
				</div>


			</div>
		);
	}

};

 

